<template>
  <div class="info-wrapper pa-3">

    <v-card class="mb-3 elevation-1 info-card">
      <v-card-text>
        <v-layout row wrap align-center justify-space-between class="mb-3">

          <v-flex xs4 class="text-xs-center text-center">
              <img height="30%" width="30%" contain :src="info.clubLocalImg" :alt="info.clubLocalNombre" v-if="info.clubLocalImg">
              <v-icon size="60" color="grey lighten-1" v-else>security</v-icon>
            <div class="font-weight-bold truncate-text">{{ info.clubLocalNombre || 'Local' }}</div>
          </v-flex>

          <v-flex xs4 class="text-xs-center text-center">
            <div class="headline font-weight-bold grey--text text--darken-1">VS</div>
          </v-flex>

          <v-flex xs4 class="text-xs-center text-center">
              <img height="30%" width="30%" contain :src="info.clubVisitorImg" :alt="info.clubVisitorNombre" v-if="info.clubVisitorImg">
              <v-icon size="60" color="grey lighten-1" v-else>security</v-icon>
            <div class="font-weight-bold truncate-text">{{ info.clubVisitorNombre || 'Visitante' }}</div>
          </v-flex>

        </v-layout>

        <v-divider></v-divider>

        <v-layout row wrap class="mt-3">
          <v-flex xs12 sm6 class="mb-2">
            <v-icon small color="primary" class="mr-2">emoji_events</v-icon>
            <span class="grey--text text--darken-2">Torneo:</span>
            <strong> {{ info.torneoNombre }}</strong>
          </v-flex>
          <v-flex xs12 sm6 class="mb-2">
            <v-icon small color="primary" class="mr-2">calendar_today</v-icon>
            <span class="grey--text text--darken-2">Fecha:</span>
            <strong> {{ info.fechaNombre }}</strong>
          </v-flex>
          <v-flex xs12 sm6 class="mb-2">
            <v-icon small color="primary" class="mr-2">schedule</v-icon>
            <span class="grey--text text--darken-2">Día y horario:</span>
            <strong> {{ info.dateRealization }}</strong>
          </v-flex>
          <v-flex xs12 sm6 class="mb-2" v-if="info.description">
            <v-icon small color="primary" class="mr-2">info</v-icon>
            <span class="grey--text text--darken-2">Estado del chat:</span>
            <strong> {{ info.chatCerrado ? 'Cerrado' : 'Abierto' }}</strong>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="elevation-1 info-card">
      <v-card-title class="grey lighten-4 py-2 px-3 border-bottom">
        <v-icon color="primary" class="mr-2">group</v-icon>
        <h3 class="subtitle-1 mb-0" style="color: #444; font-size: 1.1em;">
          Participantes ({{ info.participantes ? info.participantes.length : 0 }})
        </h3>
      </v-card-title>

      <v-list class="scrollable-list" two-line>
        <template v-if="info.participantes && info.participantes.length > 0">
          <div v-for="(user, index) in info.participantes" :key="user.id">

            <!-- AGREGAMOS LA CLASE compact-tile AQUÍ -->
            <v-list-tile avatar class="compact-tile">
              <v-list-tile-avatar>
                <!-- ACHICAMOS EL AVATAR A 36 -->
                <v-avatar color="primary" size="36">
                  <span class="white--text font-weight-bold" style="font-size: 0.9em;">{{ getIniciales(user) }}</span>
                </v-avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title class="font-weight-medium" style="color: #333; font-size: 0.95em;">
                  {{ user.firstName }} {{ user.lastName }}
                </v-list-tile-title>
                <v-list-tile-sub-title class="grey--text" style="font-size: 0.85em;">
                  {{ user.username }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-divider v-if="index + 1 < info.participantes.length" inset></v-divider>
          </div>
        </template>

        <div v-else class="text-xs-center text-center pa-5 grey--text">
          <v-icon size="40" color="grey lighten-2">person_off</v-icon>
          <div class="mt-2">No hay participantes registrados.</div>
        </div>
      </v-list>
    </v-card>

  </div>
</template>

<script>
export default {
  name: 'ChatInfoPartido',
  data () {
    return {
      info: {
        type: Object,
        default: () => ({})
      }
    }
  },
  props: {
    partidoId: {
      type: Number,
      required: true
    }
  },
  methods: {
    formatearFecha (fecha) {
      if (!fecha) return 'Sin definir'
      const d = new Date(fecha)
      return d.toLocaleString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    getIniciales (user) {
      const first = user.first_name ? user.first_name.charAt(0) : ''
      const last = user.last_name ? user.last_name.charAt(0) : ''
      let iniciales = (first + last).toUpperCase()
      // Si no tiene nombre y apellido, usamos la primera letra del username
      if (!iniciales) iniciales = user.username ? user.username.charAt(0).toUpperCase() : '?'
      return iniciales
    },
    fetchData (url) {
      const endpoint = url || `informe-auditoria/chats/partidos/${this.partidoId}/info`

      this.axios
        .get(endpoint)
        .then(response => {
          this.info = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>

<style scoped>
.info-wrapper {
  background-color: #fafafa;
  height: 100%;
  max-height: 600px;
  overflow-y: auto;
}

.info-card {
  border-radius: 8px;
  overflow: hidden;
}

.border-bottom {
  border-bottom: 1px solid #eeeeee;
}

.scrollable-list {
  max-height: none;
  overflow: hidden;
}

.compact-tile >>> .v-list__tile {
  height: 56px !important;
  padding: 0 16px;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
